// src/context/ThemeContext.tsx
import React, { createContext, useContext } from 'react';

export interface XThemeConfig {
  mode?: 'light' | 'dark';
  primaryColor?: string;
  bubble?: {
    className?: string;
    style?: React.CSSProperties;
    classNames?: Record<string, string>;
    styles?: Record<string, React.CSSProperties>;
  };
  sender?: {
    className?: string;
    style?: React.CSSProperties;
    classNames?: Record<string, string>;
    styles?: Record<string, React.CSSProperties>;
  };
  // ...其它组件配置
}

export const ThemeContext = createContext<XThemeConfig>({});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ThemeContext.Provider;
